import React, { useMemo, useState, useCallback } from 'react';
import { ImgContainer, StyledModal } from './style';
// utils
import {
  customModal,
  Container,
  Title,
  Actions,
} from '../../../utils/css/modal';
import { IModalOptions } from '../../../interfaces/admin';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import { getisIOSModalOpen } from '../../../store/actions/admin/salons.action';
import orthodoxSuccessIcon from "../../../assets/icons/orthodoxSuccessLogo.png";
import { NoSalonImage } from '../../Guests/GuestSalon/guestSalonStyles';
import ButtonSmall from '../ButtonSmall';
import { lightFont } from '../../../utils/css/fonts';
import {useIsMobile} from '../../../utils/usIsMobile';

const useGenericModal = (isDispatch: boolean = true) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalOptions, setModalOptions] = useState<IModalOptions>({});
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const openModal = useCallback(
    (options?: IModalOptions) => {
      setModalOptions(options);
      setIsModalOpen(true);
      if (isDispatch) {
        dispatch(getisIOSModalOpen(true));
      }
    },
    [setIsModalOpen, dispatch, setModalOptions]
  );

  const closeModal = useCallback(() => {
    console.count('closeModal');
    setIsModalOpen(false);
    if (isDispatch) {
      dispatch(getisIOSModalOpen(false));
    }
  }, [setIsModalOpen, dispatch]);

  const onCancel = useCallback(() => {
    const { cbCancel } = modalOptions;
    cbCancel && cbCancel();
    closeModal();
  }, [modalOptions, closeModal]);

  const onConfirm = useCallback(() => {
    const { cbConfirm } = modalOptions;
    cbConfirm && cbConfirm();
    closeModal();
  }, [modalOptions, closeModal]);

  const onRequestClose = useCallback(() => {
    const { cbCancel } = modalOptions;
    cbCancel ? cbCancel() : closeModal();
  }, [modalOptions, closeModal]);
  
  const GenericModal = useMemo(() => {
    const { options = {} } = modalOptions;
    return (props) => {
      return (
        <StyledModal
          isOpen={isModalOpen}
          onRequestClose={onRequestClose}
          ariaHideApp={false}
          style={customModal({ ...options.style }).modal}
          shouldCloseOnOverlayClick={false}
        >
          <Container dir={i18next.language === 'he' ? 'rtl' : 'ltr'}>
            <ImgContainer>
              {options.image ? ( 
                  <img src={options.image.src} alt={options.image.alt || 'logo'} /> 
              ) : (
                <NoSalonImage src={orthodoxSuccessIcon} alt='logo' />
              )}
            </ImgContainer>
            {options.title && (
              <Title 
              color={props.titleColor}
              style={options.style?.title} 
            >
              {options.title}
            </Title>
            )}
            {options.subtitle && (
              <p
                style={{
                  fontFamily: lightFont,
                  textAlign: 'center',
                  margin: '0 auto',
                  fontSize: '20px',
                  maxWidth: '420px',
                  wordWrap: 'break-word',
                  overflowWrap: 'break-word',
                  wordBreak: 'break-word',
                  whiteSpace: "pre-line",
                }}
              >
                {options.subtitle}
              </p>
            )}
            <div>{props.children}</div>
            <Actions isMobile={isMobile} justifyContent="space-around">
              <ButtonSmall
                width={204}
                height={'54px'}
                colorType={'#ffda4c'}
                colorProps={'black'}
                borderProps={'none'}
                fontSize={'16px'}
                onClick={onConfirm}
              >
                {options.ok}
              </ButtonSmall>
              <ButtonSmall
                width={204}
                height={'54px'}
                colorType={'white'}
                colorProps={'black'}
                borderProps={'1px solid #ffda4c'}
                fontSize={'16px'}
                onClick={onCancel}
              >
                {options.cancel}
              </ButtonSmall>
            </Actions>
          </Container>
        </StyledModal>
      );
    };

  }, [isModalOpen, modalOptions, onCancel, onConfirm, onRequestClose]);

  return [GenericModal, isModalOpen, openModal, closeModal] as const;
};
export default useGenericModal;